import { render, staticRenderFns } from "./ProductLayout.vue?vue&type=template&id=0bc1287e&scoped=true&"
import script from "./ProductLayout.vue?vue&type=script&lang=js&"
export * from "./ProductLayout.vue?vue&type=script&lang=js&"
import style0 from "./ProductLayout.vue?vue&type=style&index=0&id=0bc1287e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc1287e",
  null
  
)

export default component.exports